import Vue from 'vue';

export default {
  SET_ACTIVITY_UPDATING(state, { activityId, kanbanId, isUpdating = true }) {
    if (!state[kanbanId]) {
      return;
    }
    const kanbanIndex = state[kanbanId] || {};
    if (!kanbanIndex[activityId]) {
      return;
    }
    const activity = kanbanIndex[activityId] || {};
    state[kanbanId] = {
      ...kanbanIndex,
      [activityId]: {
        ...activity,
        meta: {
          isUpdating
        }
      }
    };
  },
  SET_ACTIVITY(state, { activity = {}, kanbanId, isUpdating = false }) {
    const kanbanIndex = state[kanbanId] || {};
    const currentActivity = kanbanIndex[activity.id] || {};
    Vue.set(state, kanbanId, {
      ...kanbanIndex,
      [activity.id]: {
        ...currentActivity,
        ...activity,
        ...(isUpdating && { updatedAt: Vue.moment().format('YYYY-MM-DD HH:mm:ss') }),
        meta: {
          isUpdating
        }
      }
    });
  },
  SET_ACTIVITIES(state, { activities, kanbanId }) {
    Vue.set(state, kanbanId, activities.reduce((index, activity) => ({
      ...index,
      [activity.id]: {
        ...activity,
        meta: {
          isUpdating: false
        }
      }
    }), {}));
    state.columnsActivities = activities;
  },
  SET_COLUMNS_LOADING(state, { loading }) {
    state.columnsLoading = loading;
  },
  SET_COLUMNS(state, { columns }) {
    state.columns = columns.reduce((index, column) => ({
      ...index,
      [column.id]: column
    }), {});
    state.columnsLoading = false;
  },
  SET_BINNACLE_LOADING(state, { activityId, isLoading = false }) {
    const { data = [] } = state.binnacle[activityId] || {};
    Vue.set(state.binnacle, activityId, { data, isLoading });
  },
  SET_BINNACLE(state, { activityId, items }) {
    Vue.set(state.binnacle, activityId, {
      data: items,
      isLoading: false
    });
  }
};
